import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Person2Icon from '@mui/icons-material/Person2';
import Card from 'react-bootstrap/Card';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import TRC_CONTENT from '@/constants/trcContentType';

const VideoCardV2 = ({
	video,
	product,
	customStyles,
	tagStyles,
	titleStyles,
	savedVideos = [],
	handleSaveUnsave,
	setVideoData,
	modal,
	setModal,
	hoverEffect = true,
	showAddToPlaylistIcon = false,
	showSaveIcon = false,
	shouldShowStripDescription = true,
	contentType,
	route
}) => {
	const navigate = useNavigate();
	const videoTags = video?.tagsDetails || video?.tagsData || video?.tags || [];
	const tags = Array.isArray(videoTags) ? videoTags.filter(tag => tag?.name) : [];
	const thumbnailSrc = video?.thumnailLink || video?.thumbnailLink || product?.images?.[0]?.src || '';
	const formattedDuration = formatDuration(video?.duration);
	const [isHovered, setIsHovered] = useState(false);
	const isComingSoon = tags.some(tag => tag.name.toLowerCase() === 'coming soon');
	const handleTrcContentPlay = (id) => {
		if (contentType === TRC_CONTENT.TRC) { navigate(`/trc/${route}/${id}`); }
	};



	return (
		<Card
			className="bg-dark text-white overflow-hidden m-0"
			style={{
				borderRadius: '20px',
				cursor: 'pointer',
				// filter: isComingSoon ? 'grayscale(100%)' : 'none',
				pointerEvents: isComingSoon ? 'none' : 'auto',
				...customStyles
			}}
			onMouseLeave={() => (hoverEffect ? setIsHovered(false) : null)}
			onMouseEnter={() => (hoverEffect ? setIsHovered(true) : null)}
			onClick={() => handleTrcContentPlay(video?._id)}
		>
			<Card.Img
				src={thumbnailSrc}
				alt="Card image"
				style={{
					borderRadius: '20px 20px 22px 22px',
					filter: isComingSoon ? 'grayscale(100%)' : 'none',
				}}
				
			/>
			<Card.ImgOverlay
				style={{
					background:
						hoverEffect && isHovered
							? 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 20%, rgba(0, 0, 0, 0.8) 60%)'
							: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0.5) 60%)',
					transition: 'background 0.3s ease-in-out',
					borderRadius: '20px',
					display: 'flex',
					flexDirection: 'column',
					padding: '0px 6px'
				}}
			>
				<Card.Body className="p-0" style={{ flex: '0 0 auto', height: '3.5rem' }}>
					<Card.Header className="d-flex justify-content-between align-items-center p-0">
						<Tags tags={tags} tagStyles={tagStyles} />
						<div />
						{video && (
							<div
								className="mb-0 mb-sm-1 p-1"
								onClick={e => {
									e.stopPropagation();
									setModal(!modal);
									setVideoData(video);
								}}
							>
								{showAddToPlaylistIcon && (
									<PlaylistAddIcon fontSize="large" style={{ cursor: 'pointer', color: '#6E6B7B' }} />
								)}
							</div>
						)}
					</Card.Header>
				</Card.Body>

				<Card.Body
					className="d-flex flex-column justify-content-between p-1"
					style={{ flex: '1 1 auto', overflow: 'hidden' }}
				>
					<Card.Body
						className="d-flex justify-content-between align-items-end w-100 p-0 mb-0"
						style={{ overflow: 'hidden' }}
					>
						<div
							className="d-flex flex-column align-items-start justify-content-end p-0 w-100"
							style={{
								transform: hoverEffect && isHovered ? 'translateY(-10px)' : 'translateY(0)',
								transition: 'transform 0.5s ease-in-out',
								marginTop: '10px'
							}}
						>
							{video && (
								<div className="d-flex mb-1" style={{ gap: '6px' }}>
									<span
										style={{
											fontSize: '1rem',
											backgroundColor: '#030303',
											padding: '2.5px 6px',
											marginBottom: '5px',
											borderRadius: '6px'
										}}
									>
										{formattedDuration}
									</span>
									{video?.instructor && (
										<Card.Subtitle className="p-0 m-0">
											<div
												className="d-inline-flex align-items-center video-cardv2-instructor"
												style={{
													fontSize: '1rem',
													fontWeight: '600',
													padding: '4px 8px',
													paddingBottom: '5px',
													borderRadius: '6px',
													gap: '4px',
													color: 'white',
													backgroundColor: '#030303',
													opacity: hoverEffect && isHovered ? 1 : 0,
													transition: 'opacity 0.5s ease-in-out'
												}}
											>
												<Person2Icon />
												<strong style={{ paddingTop: '3px' }}>{video?.instructor}</strong>
											</div>
										</Card.Subtitle>
									)}

								</div>
							)}


							<Card.Title
								className="text-uppercase fw-bolder video-cardv2-title"
								style={{
									fontSize: '1.2rem',
									textAlign: 'start',
									wordWrap: 'break-word',
									marginBottom: '0px',
									marginTop: '-10px',
									paddingTop: '0px',
									whiteSpace: 'normal',
									...titleStyles
								}}
							>
								{video?.title || product?.title}
							</Card.Title> 

							<Card.Text
								className="p-0 mb-0 fw-bolder video-cardv2-description"
								style={{
									maxHeight: hoverEffect && isHovered && video?.shortDescription ? '200px' : '0px',
									opacity: hoverEffect && isHovered && video?.shortDescription ? 1 : 0,
									overflow: 'hidden',
									transition: 'max-height 0.5s ease-in-out, opacity 0.5s ease-in-out',
								}}
							>
								{video?.shortDescription || ""}
							</Card.Text>

						</div>

						{showSaveIcon && (
							<div
								onClick={e => {
									e.stopPropagation();
									handleSaveUnsave(video);
								}}
								style={{
									transform: hoverEffect && isHovered ? 'translateY(-10px)' : 'translateY(0)',
									transition: 'transform 0.5s ease-in-out'
								}}
							>
								{savedVideos.length > 0 && savedVideos.includes(video._id) ? (
									<FavoriteIcon className="text-danger cursor-pointer" fontSize="large" />
								) : (
									<FavoriteBorderIcon fontSize="large" />
								)}
							</div>
						)}
					</Card.Body>
				</Card.Body>
			</Card.ImgOverlay>
		</Card>
	);
};

export const Tags = ({ tags = [], tagStyles }) => {
	return (
		<div className="c-video_tag p-1">
			<ul>
				{tags
					.filter(tag => tag?.name)
					.slice(0, 3)
					.sort((a, b) => (a?.priority || 0) - (b?.priority || 0))
					.map((tag, index) => (
						<li
							key={index}
							className="c-video_tag-entry"
							style={{
								background: tag.color,
								padding: '5px 10px',
								...tagStyles
							}}
							onClick={e => e.stopPropagation()}
						>
							<Link to={`/AllVideos?tag=${tag._id}`}>{tag.name}</Link>
						</li>
					))}
			</ul>
		</div>
	);
};

Tags.propTypes = {
	tags: PropTypes.arrayOf(
		PropTypes.shape({
			_id: PropTypes.string,
			name: PropTypes.string,
			color: PropTypes.string,
			priority: PropTypes.number
		})
	)
};

function formatDuration(seconds) {
	const totalSeconds = Number(seconds) || 0;
	const minutes = Math.floor(totalSeconds / 60);
	const remainingSeconds = totalSeconds % 60;
	const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
	return formattedTime;
}

function stripHtml(html) {
	let tempDiv = document.createElement('div');
	tempDiv.innerHTML = html;
	return tempDiv.innerText || tempDiv.textContent;
}

export default VideoCardV2;
